import type { Translations } from "../types";

const it: Translations = {
  nav: {
    features: "Funzionalità",
    pricing: "Prezzi",
    blog: "Blog",
    freeTools: "Strumenti Gratuiti",
    contact: "Contatto",
    startFree: "Inizia Gratis",
    solutions: "Soluzioni",
    useCases: "Casi d'Uso",
    switchToDark: "Passa alla Modalità Scura",
    switchToLight: "Passa alla Modalità Chiara",
    solutionsToolsDesc: "Calcolatori, generatori e altro",
    solutionsUseCasesDesc: "Scopri Zapify in azione",
  },
  hero: {
    rotatingWords: ["DM Auto", "Risposte IA"],
    headline: "Rispondi ai commenti di Instagram con",
    subheadline:
      "Rispondi automaticamente ai commenti con DM personalizzati. Cattura lead e fai crescere il tuo pubblico in automatico.",
    cta: "Inizia Gratuitamente",
    helperText: "Gratuito per iniziare",
    helperSeparator: "Configurazione facile",
    trustedBy: "Scelto da",
    creators: "5.000+ creatori",
    dmsSent: "DM Inviati",
    dmsCount: "1.000.000+",
  },
  features: {
    headingTitle: "Tutto Ciò di cui Hai Bisogno per",
    headingHighlight: "Far Crescere il tuo",
    headingDescription:
      "Zapify ti dà il controllo completo sul tuo assistente IA e sull'automazione, risparmiando ore di lavoro manuale.",
    cta: "Attiva 30 Giorni di Prova Gratuita",
    items: [
      {
        title: "Automazione dei DM",
        description:
          "Rispondi automaticamente a ogni commento Instagram con un DM. Trasforma il caos dei DM in lead qualificati e vendite.",
      },
      {
        title: "Chiedi di Seguire",
        description:
          "Prima di condividere i tuoi contenuti esclusivi, chiediamo all'utente di seguirti.",
      },
      {
        title: "Risposte potenziate dall'IA",
        description:
          "Risposte che capiscono il commento e suonano come te.",
      },
      {
        title: "Voce Completamente Personalizzabile",
        description:
          "Scegli tono e stile, risposte corte/lunghe, e controlla emoji + #hashtag.",
      },
      {
        title: "Supporto Linguistico Globale",
        description: "Parla la loro lingua, automaticamente.",
      },
      {
        title: "Raccogli Email",
        description:
          "Costruisci la tua lista email automaticamente dai commenti di Instagram.",
      },
      {
        title: "Accesso Team",
        description:
          "Invita i membri del team per gestire risposte, lead e conversazioni insieme.",
      },
      {
        title: "Account Instagram Multipli",
        description:
          "Connetti e gestisci più account Instagram da un'unica dashboard.",
      },
    ],
  },
  process: {
    headingTitle: "Inizia ad Automatizzare in",
    headingHighlight: "Minuti",
    headingDescription:
      "Segui questi semplici passaggi per automatizzare i tuoi DM",
    step: "Passo",
    cta: "Avvia Automazione",
    steps: [
      {
        title: "Seleziona i Trigger",
        description:
          "Scegli quali post e parole chiave attivano la tua automazione.",
      },
      {
        title: "Automatizza la Risposta",
        description:
          "Crea messaggi personalizzati con link, offerte o contenuti da inviare automaticamente.",
      },
      {
        title: "Virale",
        description:
          "Crea di più. Gestisci di meno. L'automazione fa il resto.",
      },
    ],
  },
  engagement: {
    headingTitle: "Trasforma l'Engagement di Instagram in",
    headingHighlight: "Entrate in Automatico",
    headingDescription:
      "Converti ogni commento in opportunità di vendita. Guadagna 24/7 mentre il tuo assistente IA gestisce le conversazioni",
    card1Title: "Aumenta i Clic sui Link",
    card1TitleLine2: "Conversioni",
    card1Description:
      "Trasforma i commenti in traffico diretto. Consegna automaticamente le tue offerte, prodotti e contenuti direttamente agli acquirenti interessati tramite DM.",
    card2Title: "Agente di Vendita IA 24/7",
    card2Description:
      "Non perdere mai un commento. Rispondi istantaneamente e converti le conversazioni in vendite 24/7 mentre dormi.",
  },
  graph: {
    headingHighlight: "Fai Decollare la tua",
    headingHighlightWord: "Portata",
    headingDescription:
      "Scopri come i DM automatizzati e le risposte IA fanno decollare il tuo tasso di engagement, la crescita dei follower e le conversioni di vendita fino a 10x",
    title: "Aumenta l'Engagement",
    by10x: "di 10x",
    subtitle: "Monetizza il tuo pubblico mentre dormi",
    description:
      "Rispondi a ogni commento, convertili in DM e aumenta l'engagement automaticamente.",
    afterZapify: "Dopo Zapify Pro",
    cta: "Aumenta l'Engagement Ora",
  },
  testimonials: {
    headingTitle: "Scopri Perché i Creator di Instagram",
    headingHighlight: "Amano",
    headingDescription:
      "Storie di successo reali di influencer e brand che hanno trasformato il loro engagement e i ricavi su Instagram con l'automazione IA",
    followers: "Follower",
  },
  faq: {
    headingTitle: "Domande",
    headingHighlight: "Frequenti",
    headingDescription:
      "Tutto quello che devi sapere per iniziare con Zapify",
    items: [
      {
        question: "Zapify funziona con qualsiasi account Instagram?",
        answer:
          "Zapify supporta gli account Instagram Professionali (Business o Creator). Gli account personali non sono supportati dall'API.",
      },
      {
        question: "Zapify è accessibile su mobile?",
        answer:
          "Sì, Zapify funziona benissimo nel tuo browser mobile, puoi installare l'App dal browser da qui.",
      },
      {
        question: "Le automazioni suoneranno robotiche?",
        answer:
          "No. Zapify supporta i controlli della voce del brand (tono, lunghezza, uso degli emoji) così le risposte IA corrispondono al tuo stile. Puoi modificare qualsiasi messaggio e aggiungere un passaggio umano.",
      },
      {
        question: "Zapify è approvato da Meta?",
        answer:
          "Zapify è un fornitore di tecnologia verificato da Meta, utilizziamo le API ufficiali di Instagram Graph. Rispettiamo i limiti di frequenza e le linee guida delle policy per mantenere il tuo account sicuro.",
      },
      {
        question: "È sicuro usare Zapify?",
        answer:
          "Sì. Tutta l'autenticazione usa OAuth sicuro di Meta. Non chiediamo mai la tua password di Instagram e rispettiamo i permessi API che concedi.",
      },
      {
        question: "Zapify è gratuito?",
        answer:
          "Offriamo una prova gratuita così puoi testare le automazioni e vedere i risultati prima di fare l'upgrade.",
      },
      {
        question: "Avete un programma partner/affiliati?",
        answer:
          "Sì. I partner approvati guadagnano commissioni sulle nuove iscrizioni e i rinnovi. Candidati sulla nostra pagina Partner.",
      },
      {
        question: "Come contatto il supporto?",
        answer:
          "Usa la chat nell'app o inviaci un'email — la maggior parte delle domande riceve una risposta lo stesso giorno nei giorni lavorativi. Forniamo anche guide di configurazione e modelli di best practice.",
      },
    ],
  },
  verified: {
    headingTitle: "Programmi",
    headingHighlight: "e Partner",
    headingDescription:
      "La nostra startup accettata da Stripe for Startups e Microsoft for Startups 2025",
    cta: "Vedi Verifica",
    badge: "Verificato",
    heading: "Il tuo fornitore di tecnologia verificato da Meta",
    description: "La nostra azienda è ufficialmente accettata in Microsoft Startups for Founders e Stripe Startup Program.",
    missionNote: "Vedi: Home → sezioni eroe e problemi dei creatori per la nostra missione e i nostri valori.",
    close: "Chiudi",
  },
  // Stats
  stats: {
    dmsSent: "DM Inviati",
    followersGained: "Follower Guadagnati",
    commentsSent: "Commenti Inviati",
    countries: "Paesi",
  },

  // Pricing
  pricing: {
    headingTitle: "Scegli il piano che",
    headingHighlight: "fa per te",
    headingDescription:
      "Prezzi flessibili per ogni creatore — cambia in qualsiasi momento e risparmia di più con la fatturazione annuale",
    monthly: "Mensile",
    yearly: "Annuale",
    get2MonthsFree: "Ottieni 2 Mesi Gratis",
    freeTrial: "Prova Gratuita",
    freeTrialDesc: "Perfetto per iniziare con Zapify.",
    starter: "Starter",
    starterDesc: "Ideale per creatori di contenuti individuali.",
    professional: "Professionale",
    professionalDesc: "Ideale per startup e piccoli brand.",
    subscribe: "Abbonati",
    startFreeTrial: "Inizia 30 Giorni di Prova Gratuita",
    free: "GRATIS",
    noCreditCard: "Senza Carta di Credito",
    bestSeller: "Più Venduto",
    perMonth: "/mese",
    save: "Risparmia",
    unlimited: "Illimitato",
    limited: "Limitato",
    email: "Email",
    priority: "Prioritario",
    automations: "Automazioni",
    dms: "DM",
    aiReplies: "Risposte IA",
    askToFollow: "Chiedi di Seguire",
    emailCollection: "Raccolta Email",
    igProfile: "Profilo IG",
    teamAccess: "Accesso Team",
    support: "Supporto",
    // Category headers
    automationPower: "Potenza Automazione",
    aiCapabilities: "Capacità IA",
    leadGeneration: "Generazione Lead",
    analyticsTeam: "Analisi & Team",
    supportPlatform: "Supporto & Piattaforma",
    soonBadge: "Presto",
    // AUTOMATION POWER features
    activeAutomations: "Automazioni attive",
    instagramAccounts: "Account Instagram",
    customTriggerWords: "Parole trigger personalizzate",
    instantDMReplies: "Risposte DM istantanee",
    commentToDMAutomation: "Automazione commento-a-DM",
    storyReplyAutomation: "Automazione risposta storie",
    welcomeMessageAutomation: "Automazione messaggio di benvenuto",
    smartGreetingMessage: "Messaggio di saluto intelligente",
    unlimitedPostsStories: "Post e storie illimitate automatizzate",
    flexiblePostTargeting: "Targeting flessibile post (prossimo, qualsiasi, multiplo)",
    linkInDMCTAButtons: "Link in DM e pulsanti CTA",
    followGatedDMsLinks: "DM e link con follow",
    instagramSafetyLimits: "Limiti di sicurezza Instagram",
    customFlowBuilder: "Builder flussi personalizzati",
    // AI CAPABILITIES features
    aiCommentReplies: "Risposte commenti IA / mese",
    aiPoweredInstantReplies: "Risposte istantanee con IA",
    aiTrainedOnBrand: "IA addestrata sul tuo brand",
    // LEAD GENERATION features
    storedContacts: "Contatti memorizzati",
    emailCaptureInsideDMs: "Cattura email nei DM",
    // ANALYTICS & TEAM features
    instagramInsights: "Insights Instagram",
    monthlyPerformanceReports: "Report prestazioni mensili",
    teamMembers: "Membri del team",
    // SUPPORT & PLATFORM features
    customerSupport: "Supporto clienti",
    languageSupport: "Supporto linguistico",
    platformBranding: "Branding della piattaforma",
    offerTitle: "Offerta a Tempo Limitato",
    offerDesc: "Registrati oggi e ottieni",
    offerBadge: "10% DI SCONTO OGGI",
    limitedSpots: "Posti Limitati",
    offerEndsIn: "L'offerta scade tra",
    days: "Giorni",
    hours: "Ore",
    minutes: "Minuti",
    seconds: "Secondi",
    claimed: "richiesto",
    secureCheckout: "Pagamento sicuro",
    noCreditCardRequired: "Nessuna carta di credito richiesta",
    copied: "COPIATO!",
    comparePlansEyebrow: "Zero chiacchiere",
    comparePlansTitle: "Decidi prima che scada la prossima Storia",
    comparePlansSubtitle:
      "Automazioni, DM, AI, team: tutto in tabella così capisci cosa vuol dire davvero \"illimitato\". Una lettura, una scelta, fine.",
    compareFeatureColumn: "Funzione",
    plansCtaBadgeLead: "Parti con intelligenza.",
    plansCtaBadgeEmphasis: "Crea di più.",
    plansCtaTitleLead: "Non costruito per trattenerti.",
    plansCtaTitleGradient: "Costruito per liberarti.",
    plansCtaSubtitle:
      "Tanti strumenti ti rendono dipendente. Noi il contrario: automatizzare il rumore, restare dove conta, trasformare le chat reali in slancio.",
    plansCtaSubtitleParagraph2:
      "Quando gira così piano che quasi non ci pensi—lì abbiamo centrato il bersaglio.",
    plansCtaBullet1: "Nessuna carta di credito",
    plansCtaBullet3: "Annulla in qualsiasi momento, senza vincoli lunghi",
    plansCtaTrust: "Oltre 5.000 creator in tutto il mondo si fidano di noi",
    signupMixEyebrow: "Istantanea iscrizioni",
    signupMixCountLabel: "iscrizioni in questo campione",
    signupMixLeadTitle: "Come hanno iniziato",
    signupMixLeadSubtitle:
      "La maggior parte parte dalla prova gratuita. Il resto si divide tra Starter e l'accesso diretto a Professional.",
    signupMixLabelFreeTrial: "Prova gratuita",
    signupMixLabelStarter: "Starter",
    signupMixLabelProfessional: "Professional",
  },

  // CTA
  cta: {
    readyToTransform: "Pronto a Trasformare il Tuo Instagram?",
    joinThousands:
      "Unisciti a migliaia di creatori e brand che usano Zapify per aumentare i follower, migliorare l'engagement e risparmiare tempo.",
    startForFree: "Inizia Gratis",
  },

  // Sticky
  sticky: {
    instantlyDm:
      "Invia DM istantaneamente a chiunque commenti sul tuo Instagram",
    limitedOffer: "Offerta a Tempo Limitato - 10% DI SCONTO",
    endsIn: "Scade tra",
    getStartedFree: "Inizia Gratuitamente",
    start: "Inizia",
  },

  // Contact Page
  contactPage: {
    heading: "Contatta il supporto",
    subtitle:
      "Siamo qui per aiutarti a crescere. Contattaci per qualsiasi domanda o assistenza.",
    connectWithUs: "Contattaci",
    connectDescription: "Scegli il tuo modo preferito per contattarci",
    emailUs: "Scrivici un'e-mail",
    emailResponse: "Risponderemo entro 24 ore",
    support: "Supporto",
    getInstantHelp: "Ottieni aiuto immediato su",
    scheduleMeet: "Prenota un incontro",
    followUs: "Seguici",
    stayUpdated: "Resta aggiornato con le ultime novità",
    responseTime: "Risposta entro 24h",
  },

  // Contact Form
  contactForm: {
    heading: "Inviaci un messaggio",
    description: "Compila il modulo qui sotto e ti risponderemo",
    fullName: "Nome completo",
    fullNamePlaceholder: "Inserisci il tuo nome completo",
    emailAddress: "Indirizzo e-mail",
    emailPlaceholder: "Inserisci il tuo indirizzo e-mail",
    subject: "Oggetto",
    subjectPlaceholder: "Di cosa si tratta?",
    message: "Messaggio",
    messagePlaceholder: "Raccontaci di più sulla tua richiesta...",
    sending: "Invio in corso...",
    sendMessage: "Invia messaggio",
    successMessage: "Messaggio inviato con successo! Ti risponderemo presto.",
    errorMessage: "Qualcosa è andato storto. Per favore riprova.",
  },

  // Blog
  blog: {
    insightsStrategy: "Approfondimenti e strategia",
    masterTheArt: "Padroneggia l'arte della",
    instagramGrowth: "crescita su Instagram",
    blogSubtitle: "Scopri guide di esperti, segreti dell'automazione e strategie verificate per trasformare i tuoi commenti in clienti.",
    searchPlaceholder: "Cerca strategie, guide...",
    followForUpdates: "Seguici per gli aggiornamenti",
    latestStories: "Ultimi articoli",
    minRead: "min di lettura",
    readStory: "Leggi l'articolo",
    featuredStory: "Articolo in evidenza",
    freshDrop: "Appena pubblicato",
    readArticle: "Leggi l'articolo",
    noArticlesFound: "Nessun articolo trovato",
    noArticlesDescription: "Non abbiamo trovato articoli corrispondenti alla tua ricerca. Prova a modificare i filtri o ricontrolla più tardi.",
    clearSearch: "Cancella ricerca",
  },

  // Referral
  referral: {
    heading: "Unisciti al nostro programma di",
    headingHighlight: "Referral",
    description: "Consiglia Zapify ai tuoi amici e guadagna il 20% del fatturato totale che spendono per un abbonamento a pagamento durante il primo anno.",
    proSubscriber: "Abbonato Zapify Pro",
    minimumDms: "aver inviato almeno 100 DM",
    joinProgram: "Unisciti al programma di referral",
    termsOfService: "termini di servizio.",
    step1: "Passo 1",
    step1Title: "Ottieni il tuo link di referral",
    step1Desc: "Registrati in pochi minuti — nessuna approvazione necessaria! Se sei un abbonato Pro con oltre 100 DM inviati, puoi iniziare a guadagnare.",
    referralLink: "Link di referral",
    copy: "Copia",
    step2: "Passo 2",
    step2Title: "Condividi e promuovi",
    step2Desc: "Copia il tuo link e condividilo ovunque — Instagram, TikTok, YouTube, email o DM. Più condividi, più guadagni!",
    step3: "Passo 3",
    step3Title: "Guadagna il 20% di commissione",
    step3Desc: "Quando qualcuno passa a un piano a pagamento usando il tuo link, guadagni il 20% dei suoi pagamenti per il primo anno — pagato mensilmente!",
    quickStats: "Statistiche rapide",
    clicks: "Clic",
    converted: "Convertiti",
    total: "Totale",
    pending: "In sospeso",
    faqHeading: "Programma di referral",
    faqSubheading: "Le domande più frequenti sul nostro programma di referral",
    faq1Q: "Cos'è il programma di referral di Zapify?",
    faq1A: "Il programma di referral di Zapify ti permette di guadagnare commissioni segnalando nuovi utenti alla nostra piattaforma. Quando qualcuno si iscrive a un piano a pagamento usando il tuo link unico, guadagni il 20% delle sue quote di abbonamento per il primo anno.",
    faq2Q: "Chi può partecipare al programma di referral?",
    faq2A: "Per partecipare, devi essere abbonato Zapify Pro e aver inviato almeno 100 DM utilizzando i nostri strumenti di automazione. Questo assicura che i nostri affiliati siano utenti attivi che possono raccomandare genuinamente la piattaforma.",
    faq3Q: "Come e quando vengo pagato?",
    faq3A: "Le commissioni vengono pagate mensilmente tramite PayPal una volta che i tuoi guadagni raggiungono la soglia minima di $50. I pagamenti vengono elaborati circa 30 giorni dopo la fine del mese in cui sono stati generati.",
    faq4Q: "C'è un limite a quanto posso guadagnare?",
    faq4A: "No! Non c'è alcun tetto ai tuoi guadagni. Più referral di successo fai, più guadagni.",
  },

  // Tools Page
  toolsPage: {
    heading: "Strumenti Instagram",
    headingHighlight: "gratuiti",
    description:
      "Calcolatori, generatori, strumenti di formattazione e altro — tutti gratuiti, senza registrazione. Creati per i creatori che vogliono crescere in modo intelligente.",
    searchPlaceholder: "Cerca strumenti...",
    all: "Tutti",
    noToolsFound: "Nessuno strumento trovato corrispondente alla tua ricerca.",
    free: "Gratuito",
    comingSoon: "In arrivo",
    relatedTools: "Strumenti correlati",
    relatedToolsDesc: "Altri strumenti gratuiti per far crescere il tuo Instagram",
    viewAllTools: "Vedi tutti gli strumenti gratuiti",
    frequentlyAsked: "Domande",
    questionsHighlight: "frequenti",
    faqDescription: "Tutto quello che devi sapere su",
  },

  // Use Case
  useCase: {
    heading: "Cosa puoi automatizzare con",
    headingHighlight: "Zapify?",
    description: "Dalla generazione di vendite alla raccolta di email — scopri come i creatori e i brand usano Zapify per automatizzare i loro DM su Instagram e crescere in automatico.",
    startForFree: "Inizia gratis",
    learnMore: "Scopri di più",
    bottomCtaHeading: "Pronto ad automatizzare i tuoi DM su Instagram?",
    bottomCtaDesc: "Unisciti a migliaia di creatori che usano Zapify per trasformare le conversazioni in vendite — automaticamente.",
    freeToStart: "Gratuito per iniziare · Configurazione facile",
  },

  footer: {
    description:
      "Lo strumento #1 per l'automazione dei DM di Instagram, scelto da oltre 5.000 creatori in tutto il mondo.",
    product: "Prodotto",
    company: "Azienda",
    compare: "Confronta",
    howItWorks: "Come funziona",
    termsOfService: "Termini di Servizio",
    privacyPolicy: "Informativa sulla Privacy",
    refundPolicy: "Politica di Rimborso",
    contactUs: "Contattaci",
    referralProgram: "Programma di Referral",
    copyright: "Tutti i diritti riservati.",
    builtWith: "Fatto con \u2764\uFE0F per i creatori",
    useCasesHeading: "Casi d'uso",
    allUseCases: "Tutti i casi d'uso",
    sendLinksInDms: "Inviare link nei DM",
    autoRespondComments: "Risposte automatiche ai commenti",
    collectEmails: "Raccogliere e-mail",
    storyReplies: "Risposte alle storie",
  },

  // Auth
  auth: {
    welcomeToZapify: "Benvenuto su Zapify",
    setItUpOnce: "Configuralo una volta. Lascia che l'IA faccia il resto.",
    recommended: "Consigliato",
    continueWithInstagram: "Continua con Instagram",
    continueWithGoogle: "Continua con Google",
    redirecting: "Reindirizzamento...",
    orContinueWithEmail: "o continua con e-mail",
    emailAddress: "Indirizzo e-mail",
    emailRequired: "L'e-mail è obbligatoria",
    validEmail: "Inserisci un'e-mail valida",
    sendingCode: "Invio del codice...",
    startFree: "Inizia gratis",
    enterVerificationCode: "Inserisci il codice di verifica",
    weSentCode: "Abbiamo inviato un codice a 6 cifre a",
    otpRequired: "Il codice OTP è obbligatorio",
    otpDigits: "Il codice OTP deve avere 6 cifre",
    verifying: "Verifica in corso...",
    verifyAndContinue: "Verifica e continua",
    useDifferentEmail: "Usa un'altra e-mail",
    agreeToTerms: "Continuando, accetti i nostri",
    termsOfService: "Termini di Servizio",
    and: "e",
    privacyPolicy: "Informativa sulla Privacy",
    haveDiscountCode: "Hai un codice sconto?",
    discountCode: "Codice sconto",
    enterCode: "Inserisci il codice",
    apply: "Applica",
    applied: "Applicato",
    congratsDiscount: "Complimenti! Hai ottenuto un 20% di sconto extra.",
    invalidCode: "Codice sconto non valido",
    redirectingToDashboard: "Reindirizzamento alla dashboard...",
    referralBannerText: "Complimenti! Hai ottenuto un 20% di sconto extra.",
    extendedTrialBannerText: "Complimenti! Hai sbloccato {days} giorni di prova gratuita.",
  },

  // Comparison
  comparison: {
    updatedDate: "Aggiornato a marzo 2026",
    startFreeNoCreditCard: "Inizia gratis — Senza carta di credito",
    seeFullComparison: "Vedi il confronto completo",
    quickAnswer: "Risposta rapida",
    featureComparison: "Confronto funzionalità per funzionalità",
    samePriceTitle: "Stesso prezzo, ma cosa ottieni davvero?",
    aiVsKeywords: "Riconoscimento dell'intento con IA vs modelli base di parole chiave",
    userComments: "Cosa scrivono davvero gli utenti nei commenti:",
    bottomCtaHeading: "Pronto a provare l'alternativa più intelligente?",
    bottomCtaDesc: "Unisciti a migliaia di creatori che sono passati a Zapify per l'automazione Instagram con IA.",
    getStarted: "Inizia gratuitamente",
    freeToStart: "Gratuito per iniziare · Nessuna carta di credito richiesta",
    feature: "Funzionalità",
    category: "Categoria",
    pricingTiers: "Livelli di prezzo",
    faq: "Domande frequenti",
  },

  // Legal
  legal: {
    lastUpdated: "Ultimo aggiornamento",
    haveQuestions: "Hai domande?",
    contactEmail: "Non esitare a contattarci a",
    returnToWebsite: "Torna al sito web",
    termsOfService: "Termini di Servizio",
    privacyPolicy: "Informativa sulla Privacy",
    refundPolicy: "Politica di Rimborso",
    dataDeletion: "Politica di cancellazione dei dati",
  },

  // Use Case Layout
  useCaseLayout: {
    startForFree: "Inizia gratis",
    freeToStart: "Gratuito per iniziare · Configurazione facile",
    frequentlyAsked: "Domande",
    questionsHighlight: "frequenti",
    readyToAutomate: "Pronto ad automatizzare i tuoi DM su Instagram?",
    readyToAutomateDesc: "Unisciti a migliaia di creatori che usano Zapify per trasformare le conversazioni in vendite — automaticamente.",
    trigger: "Trigger:",
    response: "Risposta:",
    exploreMore: "Scopri di più",
  },
};

export default it;
